import {
  Box,
  Checkbox,
  FormControl,
  InputAdornment,
  MenuItem,
  Select,
} from "@mui/material";
import React, { useState } from "react";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDown";
import CheckBoxOutlineBlankRoundedIcon from "@mui/icons-material/CheckBoxOutlineBlankRounded";
import CheckBoxRoundedIcon from "@mui/icons-material/CheckBoxRounded";
import filter from "../../src/Assets/Image/filter.png";
import filterOrange from "../../src/Assets/Image/filterOrange.png";

const DropDownComponent = ({
  value,
  handleChange,
  options,
  check,
  placeholder,
  defIcon = null,
  startAdornment = true,
  bgColor,
  color,
}) => {
  const [open, setOpen] = useState(false); // State to control dropdown open

  return (
    <FormControl
      sx={{
        backgroundColor: bgColor,
        borderRadius: "12px",
        border: "1px solid #FD5D29",
        color: color,
        width: "fit-content",
        "& .MuiOutlinedInput-input:focus ": {
          borderRadius: "12px",
        },
        ".MuiSelect-select": {
          color: color,
          borderRadius: "12px",
        },
        "& .MuiInputBase-root": {
          border: "none",
          borderRadius: "12px",
        },
        "& fieldset": {
          border: "none",
          borderRadius: "12px",
        },
      }}
    >
      <Select
        value={value || ""}
        onChange={handleChange}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        sx={{
          ".MuiSelect-select": {
            padding: 1,
            outline: "none",
          },
          ".MuiSelect-icon": {
            color: color,
          },
        }}
        IconComponent={defIcon ? undefined : () => null}
        startAdornment={
          startAdornment && (
            <InputAdornment position="start">
              <img
                src={color === "#FFF" ? filter : filterOrange}
                alt=""
                height={25}
                width={25}
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  e.stopPropagation(); // Prevent default select behavior
                  setOpen((prev) => !prev);
                }}
              />
            </InputAdornment>
          )
        }
        MenuProps={{
          PaperProps: {
            sx: {
              backgroundColor: "#FFF6F3",
              color: "#000",
              fontSize: "14px",
            },
          },
        }}
        renderValue={(selected) => {
          const selectedOption = options.find(
            (option) => option.value === selected
          );
          return selectedOption ? selectedOption.label : placeholder;
        }}
      >
        <MenuItem value={99} sx={{ display: "none" }}>
          {placeholder}
        </MenuItem>

        {options?.map((x, i) => (
          <MenuItem
            sx={{
              "&.MuiMenuItem-root:hover": {
                color: "ffffff95",
                "& .MuiCheckbox-root": {
                  color: "ffffff95",
                },
              },
            }}
            key={i}
            value={x.value}
          >
            <Box sx={{ display: "flex", alignItems: "center", p: 0.5 }}>
              {check && (
                <Checkbox
                  checkedIcon={
                    <CheckBoxRoundedIcon
                      style={{ color: "#D8D4FF", fontSize: "20px" }}
                    />
                  }
                  icon={
                    <CheckBoxOutlineBlankRoundedIcon
                      style={{ color: "#D8D4FF", fontSize: "20px" }}
                    />
                  }
                  checked={x.value === value}
                />
              )}
              {x.label}
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default DropDownComponent;
